import { render, staticRenderFns } from "./lp-top.vue?vue&type=template&id=e00cca96&"
import script from "./lp-top.vue?vue&type=script&lang=js&"
export * from "./lp-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports